/* eslint-disable no-unused-vars */
import {
  getEvents,
  deleteEvent,
  getEventsOfAnyStore,
  getEventByID,
  getTypeEvent,
  getValidEvents,
  getLinkedEvents,
  uploadEventImage,
  getVariations,
  getAccessTypes,
  registerBins,
  getBins,
} from "@/api";
import eventBus from "../../utils/eventBus";
import { i18n } from "../../main";

const state = {
  events: [],
  eventsTemp: [],
  eventsLoading: false,
  typeEvents: [],
  typeVariations: [
    { value: "CORTESIA", text: "Cortesia" },
    { value: "GRATUIDADE", text: "Gratuidade" },
  ],
  hasLinkedEvents: false,
  allValidEvents: [],
  linkedEventsList: [],
  linkedEvents: [],
  images: [],
  image2: null,
  uploadLoading: false,
  eventId: null,

  variations: [],
  variationsLoading: false,
  optionVariations: [],
  variationsOld: [],
  digitalWallet: [
    {
      dias: "2",
      tipo: "pos",
      limite: 80,
      saque: "manual",
    },
  ],
  binsData: [],
  binsLoading: false,
};

const getters = {
  allEvents: state => state.events,
  allTempEvents: state => state.eventsTemp,
  eventsLoading: state => state.eventsLoading,
  typeEvents: state => state.typeEvents,
  typeVariations: () => [
    { value: "CORTESIA", text: i18n.t("reports.courtesy") },
    { value: "GRATUIDADE", text: i18n.t("reports.free") },
  ],
  hasLinkedEvents: state => state.hasLinkedEvents,
  allValidEvents: state => state.allValidEvents,
  linkedEventsList: state => state.linkedEventsList,
  linkedEvents: state => state.linkedEvents,
  images: state => state.images,
  image2: state => state.image2,
  uploadLoading: state => state.uploadLoading,
  eventId: state => state.eventId,
  variations: state => state.variations,
  variationsLoading: state => state.variationsLoading,
  optionVariations: state => state.optionVariations,
  variationsOld: state => state.variationsOld,
  digitalWallet: state => state.digitalWallet,
  binsData: state => state.binsData,
  binsLoading: state => state.binsLoading,
};

const actions = {
  fetchEvents({ commit, getters }, params) {
    const { ...rest } = params;
    commit("setEventsLoading", true);
    getEvents(
      rest.producerId || getters.storeSequencial,
      rest.filtro ? rest.filtro : rest,
      rest.periodo_valido
    ).then(response => {
      commit("setEvents", response.data);
      commit("setEventsTemp", response.data);
      commit("setEventsLoading", false);
    });
  },
  fetchEventsOfAnyStore({ commit }, params) {
    const { producers, ...rest } = params;
    commit("setEventsLoading", true);
    getEventsOfAnyStore(
      producers,
      rest.filtro ? rest.filtro : rest,
      rest.periodo_valido
    ).then(response => {
      commit("setEvents", response.data);
      commit("setEventsTemp", response.data);
      commit("setEventsLoading", false);
    });
  },
  fethEventsByID({ commit }, params) {
    const { idproduto } = params;
    commit("setEventsLoading", true);
    getEventByID(idproduto).then(response => {
      commit("setEvents", response.data);
      commit("setEventsLoading", false);
    });
  },
  fetchTypeEvent({ commit }, params) {
    commit("setEventsLoading", true);
    getTypeEvent().then(response => {
      commit("setTypeEvent", response.data);
      commit("setEventsLoading", false);
    });
  },
  deleteEvent({ commit, dispatch }, { producerId, eventId }) {
    deleteEvent(producerId, eventId).then(() => {
      dispatch("fetchEvents", producerId);
    });
  },
  fetchValidEvents({ commit }, params) {
    const { slug } = params;
    getValidEvents(slug).then(response => {
      commit("setValidEvents", response.data);
    });
  },
  fetchLinkedEventsList({ commit }, producer) {
    getLinkedEvents(producer).then(response => {
      commit("setLinkedEventsList", response.data);
    });
  },
  setLinkedEvents({ commit }, events) {
    commit("setLinkedEvents", events);
  },
  setHasLinkedEvents({ commit }, hasLinkedEvents) {
    commit("setHasLinkedEvents", hasLinkedEvents);
  },
  uploadEventImage({ commit, state }, content) {
    commit("setUploadLoading", true);

    uploadEventImage(content)
      .then(response => {
        const obj = {
          url: response.data.url,
          type: content.image,
          id: response.data.idproduto,
        };
        commit("setEventId", response.data.idproduto);
        commit("setImages", [...state.images, obj]);
        commit("setUploadLoading", false);
      })
      .catch(error => {
        console.error(error);
        commit("setUploadLoading", false);
      })
      .finally(() => {
        commit("setUploadLoading", false);
        eventBus.$emit("upload-image");
      });
  },
  getImage2({ commit }, content) {
    uploadEventImage(content)
      .then(response => {
        commit("setImage2", response.data.url);
      })
      .catch(error => {
        console.error(error);
      });
  },
  getImagesFromRegister({ commit }, images) {
    function extractIdFromUrl(url) {
      const parts = url?.split("/");

      return parts && parts[parts.length - 2];
    }
    const formattedImages = [];

    formattedImages.push({
      url: images.destaque,
      type: "destaque",
      id: extractIdFromUrl(images.destaque),
    });
    formattedImages.push({
      url: images.imagem1,
      type: "imagem1",
      id: extractIdFromUrl(images.imagem1),
    });
    if (images.map) {
      formattedImages.push({
        url: images.map,
        type: "map",
        id: extractIdFromUrl(images.map),
      });
    }
    commit("setImages", formattedImages);
  },

  cleanImagesFromRegister({ commit }) {
    commit("setImages", []);
  },
  fetchVariations({ commit, getters }, opcoes) {
    commit("setVariationsLoading", true);
    getVariations({
      loja: getters.storeSequencial,
      opcoes: opcoes,
      variacoes_produto:
        getters.variations?.length > 0
          ? getters.variations
          : getters.variationsOld,
    }).then(response => {
      commit("setOptionVariations", opcoes);
      commit("setVariations", response.data);
      commit("setVariationsLoading", false);
    });
  },
  exportAccessTypes({ commit }, idproduto) {
    getAccessTypes(idproduto).then(response => {
      const blob = new Blob([response.data], { type: "text/csv" });

      const a = document.createElement("a");
      a.href = window.URL.createObjectURL(blob);
      a.download = "Relatório de tipos de acesso";
      a.click();
    });
  },
  registerOrUpdateBins({ dispatch }, params) {
    const {
      idproduto_variacao,
      iddesconto_bin,
      desconto_valor,
      desconto_perc,
      bins,
      banco,
      descricao,
      status,
      dthr_inicio,
      dthr_fim,
      idproduto,
      eventId,
    } = params;

    registerBins(
      idproduto_variacao,
      iddesconto_bin,
      desconto_valor,
      desconto_perc,
      bins,
      banco,
      descricao,
      status,
      dthr_inicio,
      dthr_fim,
      idproduto,
      eventId
    )
      .then(() => {
        dispatch("getBins", eventId);
        dispatch("showSnackbarSuccess", "Desconto salvo com sucesso!");
      })
      .catch(() => {
        dispatch("showSnackbarError", "Erro ao salvar desconto!");
      });
  },
  getBins({ commit, dispatch }, idproduto) {
    commit("setBinsLoading", true);

    getBins(idproduto)
      .then(response => {
        commit("setBinsData", response.data);
        commit("setBinsLoading", false);
      })
      .catch(() => {
        dispatch("showSnackbarError", "Erro ao listar descontos!");
      });
  },
};

const mutations = {
  setEvents: (state, events) => {
    state.events = events;
  },
  setEventsTemp: (state, events) => {
    state.eventsTemp = events;
  },
  setEventsLoading: (state, eventsLoading) => {
    state.eventsLoading = eventsLoading;
  },
  setTypeEvent: (state, events) => {
    state.typeEvents = events;
  },
  setValidEvents: (state, events) => {
    state.allValidEvents = events;
  },
  setLinkedEventsList: (state, events) => {
    state.linkedEventsList = events;
  },
  setLinkedEvents: (state, events) => {
    state.linkedEvents = events;
  },
  setHasLinkedEvents: (state, hasLinkedEvents) => {
    state.hasLinkedEvents = hasLinkedEvents;
  },
  setImages: (state, images) => {
    state.images = images;
  },
  setImage2: (state, image2) => {
    state.image2 = image2;
  },
  setUploadLoading: (state, uploadLoading) => {
    state.uploadLoading = uploadLoading;
  },
  setEventId: (state, eventId) => {
    state.eventId = eventId;
  },
  setVariations: (state, variations) => {
    state.variations = variations;
  },
  setVariationsLoading: (state, variationsLoading) => {
    state.variationsLoading = variationsLoading;
  },
  setOptionVariations: (state, optionVariations) => {
    state.optionVariations = optionVariations;
  },
  setVariationsOld: (state, variationsOld) => {
    state.variationsOld = variationsOld;
  },
  setDigitalWallet: (state, digitalWallet) => {
    state.digitalWallet = digitalWallet;
  },
  setBinsData: (state, binsData) => {
    state.binsData = binsData;
  },
  setBinsLoading: (state, binsLoading) => {
    state.binsLoading = binsLoading;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
